import Carousel from 'components/carousel/Carousel';
import './CarouselContainer.scss';
import { PropsWithChildren } from 'react';

const CarouselContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="carousel-container-root">
      <div className="carousel-container-content">
        <div className="carousel-section">
          <Carousel />
        </div>

        <div className="children-section">

          <div className="children-content">
            {children}
          </div>


        </div>

      </div>

    </div>
  );
};

export default CarouselContainer;
